<!--登录-->
<template>
  <div class="login">
    <div class="left-box">
      <Carousel
        autoplay
        v-model="carouselIndex"
        arrow="never"
        radius-dot
        :autoplay-speed="3000"
      >
        <CarouselItem>
          <a target="_blank" href="https://aidprint.com/product_aidprint">
            <div class="car-item">
              <img class="img" src="../../assets/images/ic_aidprint.png" />
              <div class="title">
                <img
                  style="width: 40px; height: 40px; margin-right: 15px"
                  src="../../assets/images/ic_banner1.png"
                />
                通用基础版
              </div>
              <div class="des">满足全场景自助共享文印的全能型选手</div>
            </div>
          </a>
        </CarouselItem>
        <CarouselItem>
          <a target="_blank" href="https://aidprint.com/product_custprint">
            <div class="car-item">
              <img class="img" src="../../assets/images/ic_custprint.png" />
              <div class="title">
                <img
                  style="width: 40px; height: 40px; margin-right: 15px"
                  src="../../assets/images/ic_banner2.png"
                />
                服务窗口版
              </div>
              <div class="des">用心为特定场景和使用人群而打造</div>
            </div>
          </a>
        </CarouselItem>
        <CarouselItem>
          <a target="_blank" href="https://aidprint.com/product_ops">
            <div class="car-item">
              <img class="img" src="../../assets/images/ic_product_ops.png" />
              <div class="title">
                <img
                  style="width: 40px; height: 40px; margin-right: 15px"
                  src="../../assets/images/ic_banner3.png"
                />
                智能运维
              </div>
              <div class="des">设备远程运维管理和服务流程的好帮手</div>
            </div>
          </a>
        </CarouselItem>
      </Carousel>
    </div>
    <div class="login-box">
    <div class="a-link" @click="jump1">特约合作伙伴入口>></div>

      <a href="https://www.aidprint.com" target="_blank">
        <img src="../../assets/images/login-logo.png" alt class="logo" />
      </a>
      <div class="login-box-from">
        <div class="head-box">
          <span class="login-title">登录</span>
          <span @click="PartnerModel = true">开通合作伙伴</span>
        </div>
        <div class="item">
          <input
            type="text"
            placeholder="请输入合作伙伴账号"
            class="input"
            v-model="code"
            @focus="accountFocus = true"
            @blur="accountFocus = false"
          />
          <div class="icon-box" :class="{ 'icon-box-f': accountFocus }">
            <img :src="accountFocus ? accountImg2 : accountImg" class="icon" />
          </div>
        </div>
        <div class="item">
          <input
            :type="pwdText ? 'text' : 'password'"
            class="input"
            placeholder="请输入密码"
            v-model="password"
            @focus="pwdFocus = true"
            @blur="pwdFocus = false"
          />
          <div class="icon-box" :class="{ 'icon-box-f': pwdFocus }">
            <img :src="pwdFocus ? pwdImg2 : pwdImg" class="icon" />
          </div>
          <img
            class="eye"
            :src="pwdText ? eyeImg2 : eyeImg"
            @click="pwdText ? (pwdText = false) : (pwdText = true)"
          />
        </div>
        <div class="outher-box">
          <Checkbox v-model="isSaveLogin">保持登录</Checkbox>
          <span class="passzh-btn" @click="tips"> 忘记密码? </span>
        </div>
        <div class="login-btn" @click="handleSubmit">立即登录</div>
        <div class="payment-login" @click="jump">收款人登录</div>
      </div>
    </div>
    <Modal
      v-model="PartnerModel"
      title
      @on-cancel="PartnerCancel"
      width="1062"
      class-name="Partner"
      :footer-hide="true"
    >
      <p class="PartnerTitle">合作伙伴申请填写</p>
      <p class="des">请提供一些详细信息，我们尽快与您联系</p>
      <div class="PartnerForm">
        <Input
          v-model="formData.contacts"
          placeholder="姓名"
          class="input item"
        />
        <Input v-model="formData.tel" placeholder="手机号码" class="input" />
        <Input
          v-model="formData.email"
          placeholder="电子邮箱"
          class="input item"
        />
        <Input v-model="formData.name" placeholder="公司名称" class="input" />
        <Cascader
          :data="cityData"
          class="company-area input item"
          placeholder="请选择所在地区"
          v-model="area"
        ></Cascader>
        <Input
          v-model="formData.address"
          placeholder="详细地址"
          class="input"
        />
        <Select
          class="company-select select"
          placeholder="请选择感兴趣的产品"
          v-model="formData.product"
        >
          <Option
            v-for="item in selectData"
            :value="item.value"
            :key="item.value"
            >{{ item.value }}</Option
          >
        </Select>
        <Select
          class="company-select select"
          placeholder="预想接入硬件品牌"
          v-model="formData.brand"
        >
          <Option value="理光" key="1">理光</Option>
          <Option value="京瓷" key="2">京瓷</Option>
          <Option value="佳能" key="3">佳能</Option>
        </Select>
      </div>
      <div class="form-footer-box">
        <p class="btn-submit" @click="!loading ? PartnerOk() : null">
          提交申请
        </p>
        <p style="color: #a6a6a6; font-size: 12px; text-align: center">
          <a
            target="_blank"
            style="color: #a6a6a6"
            :href="config.baseUrl.pro + '/page?p=usage-protocol'"
            >查看合作伙伴服务协议</a
          >
        </p>
      </div>
    </Modal>
    <Modal v-model="SuccessModel" title width="600" :footer-hide="true" :closable="false">
      <div class="success-model-content">
        <div class="title">申请成功</div>
        <div class="des">
          我们将尽快受理申请，您也可以直接拨打4001886966与人工客服取得联系!
        </div>
        <div class="close" @click="SuccessModel=false">关闭</div>
      </div>
    </Modal>
  </div>
</template>

<script>
import LoginForm from '_c/login-form'
import { mapActions, mapGetters } from 'vuex'
import cityData from '../../libs/city.data'
import config from '../../config'
export default {
  data () {
    return {
      config,
      PartnerModel: false,
      cityData: cityData,
      loading: false,
      accountImg: require('../../assets/images/ic_login_account.png'),
      accountImg2: require('../../assets/images/ic_login_account_t.png'),
      pwdImg: require('../../assets/images/ic_login_pwd.png'),
      pwdImg2: require('../../assets/images/ic_login_pwd_t.png'),
      eyeImg: require('../../assets/images/ic_login_eye.png'),
      eyeImg2: require('../../assets/images/ic_login_eye_c.png'),
      accountFocus: false,
      pwdFocus: false,
      pwdText: false,
      isSaveLogin: false, // 是否保持登录
      code: '',
      password: '',
      carouselIndex: 0,
      formData: {
        contacts: '',
        tel: '',
        email: '',
        name: '',
        address: '',
        product: '',
        area: '',
        brand: ''
      },
      area: [],
      selectData: [
        {
          value: '云知印（云打印、复印、扫描）'
        },
        {
          value: '智能运维'
        }
      ],
      SuccessModel: false
    }
  },
  components: {
    LoginForm
  },
  mounted () {
    // 云知印官网底部点击的免费测试
    let apply = this.getUrlParam('apply')
    if (apply) {
      this.PartnerModel = true
    }
    console.log('token', sessionStorage.getItem('token'))
    if (sessionStorage.getItem('token')) {
      this.$router.push({
        name: this.$config.homeName
      })
    }
  },
  methods: {
    ...mapActions(['handleLogin', 'userCompany']),

    // 获取url链接的参数
    getUrlParam (name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      var r = window.location.search.substr(1).match(reg)
      if (r != null) return decodeURI(r[2])
      return null
    },
    handleSubmit () {
      if (!this.code) {
        this.$Message.error('请输入合作伙伴账号')
        return false
      }
      if (!this.password) {
        this.$Message.error('请输入密码')
        return false
      }
      let code = this.code
      let password = this.password
      this.handleLogin({ code, password }).then((res) => {
        if (res.status) {
          this.$Message.success(res.msg)
          this.$router.push({
            name: this.$config.homeName
          })
        } else {
          this.$Message.error(res.msg)
        }
      })
    },
    PartnerOk () {
      if (!this.formData.contacts) {
        this.$Message.error('请输入姓名')
        return false
      }
      if (!this.formData.tel) {
        this.$Message.error('请输入手机号码')
        return false
      }
      const myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/
      if (!myreg.test(this.formData.tel)) {
        this.$Message.error('手机号码填写错误')
        return false
      }
      if (!this.formData.email) {
        this.$Message.error('请填写电子邮箱')
        return false
      }
      const strRegex = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
      if (!strRegex.test(this.formData.email)) {
        this.$Message.error('电子邮箱填写错误')
        return false
      }
      if (this.area.length < 1) {
        this.$Message.error('请选择所在地区')
        return false
      }
      if (!this.formData.address) {
        this.$Message.error('请填写详细地址')
        return false
      }
      this.formData.province = this.area[0]
      this.formData.city = this.area[1]
      this.formData.area = this.area[2]
      this.formData.type = 1
      this.loading = true
      console.log(this.formData)
      this.userCompany(this.formData).then((res) => {
        this.loading = false
        this.formData = {
          contacts: '',
          tel: '',
          email: '',
          name: '',
          address: '',
          product: '',
          area: '',
          brand: ''
        }
        // this.$Message.success("申请成功，请耐心等待工作人员联系");
        this.PartnerModel = false
        this.SuccessModel = true
      })
    },
    PartnerCancel () {},
    tips () {
      this.$Message.error('请联系服务商重置密码')
    },
    jump () {
      window.open(config.payment, '_blank')
    },
    jump1 () {
      window.open(config.school, '_blank')
    }
  },
  computed: mapGetters({
    socket: 'socket'
  })
}
</script>
<style lang="less">
@import "./login.less";
</style>
